let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aW2bK")).then(() => parcelRequire('49Cii'));